module.exports = __webpack_public_path__ + "img/success.a97d09d7.png";